import React, { useState, useEffect } from "react";
// import aboutUs from "../../PicesForPages/clientReviewjpg.jpg";

import { Link } from "react-router-dom";

const reviews = [
  {
    content:
      "He is very honesty and gentle.It was a great experience working with Kumar for my mortgage application. He explained all costs and tried to give the best deal. Great thing is, the initial numbers doesn’t change till the end of the process.",
    name: "- Ram Garapati",
  },
  {
    content:
      "Kumar is very honest and informed loan officer, he guided me through the process and helped in securing best deal available. He was very patient with my questions and was always available for clarifying doubts. Highly recommended.",
    name: "- Javed Shaikh",
  },
  {
    content:
      "It was a great experience working with Kumar Sista for my mortgage application. He clearly explains all costs and tried to give the best deal. Great thing is, the initial numbers doesn't change till the end of the process unlike others.\n\nAnd he is always a text message away to reach out for any clarifications. I 100% recommend this loan officer.",
    name: "- Venu Babu Karri",
  },
  {
    content:
      "We would like to acknowledge the exceptional service that we received during the entire refinancing process. Kumar Sista and Team professionalism and knowledge of the industry were impressive and truly appreciated. Kumar went above and beyond to ensure that all our needs were met and that everything was handled thoroughly and efficiently. We have and will continue to recommend him in the future.",
    name: "- MVaneet Kaushik",
  },
  {
    content:
      "I had an outstanding experience working with Loan Officer's. From start to finish, they were professional, knowledgeable, and extremely helpful in guiding me through the entire loan process. They took the time to explain all the details, answered all my questions, and worked tirelessly to secure the best rates for me. I felt supported every step of the way.",
    name: "- Divya Pothuri",
  },
];

function ClientReview() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % reviews.length);
    }, 4000); // Change every 4 seconds
    return () => clearInterval(interval);
  }, []);

  const currentReview = reviews[currentIndex];

  return (
    <>
      {/* <div className="purchaseParent">
    <div className="purchasetopParent">
        <img   fetchPriority="high"
                    loading="eager"
          src={aboutUs}
          alt="aboutUsImage"
          className="background-video aboutUsImage"
        />
        <div className="purchasetopBox">Google Reviews</div>
      </div>

    </div>*/}
      <div className="OurSatisfiedBoxParent">
        <div className="OurSatisfiedBox fade-in">
          <span className="OurSatisfiedHeading">Our Satisfied Clients</span>
          <span className="OurSatisfiedContentBox">
            <span className="OurSatisfiedStars">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
            </span>
            <span className="OurSatisfiedContent">
              {currentReview.content
                .split("The Mortgageist")
                .map((part, i, arr) =>
                  i < arr.length - 1 ? (
                    <React.Fragment key={i}>
                      {part}
                      <span className="logoBoldColor">The Mortgageist</span>
                    </React.Fragment>
                  ) : (
                    part
                  ),
                )}
            </span>
            <span className="OurSatisfiedNameLocation">
              <span className="OurSatisfiedName">{currentReview.name}</span>
            </span>
          </span>
        </div>

        <span className="OurSatisfiedArrows">
          <i
            className="ri-arrow-left-wide-fill OurSatisfiedLeftArrow"
            onClick={() =>
              setCurrentIndex((prev) =>
                prev === 0 ? reviews.length - 1 : prev - 1,
              )
            }
          ></i>
          <i
            className="ri-arrow-right-wide-fill OurSatisfiedRightArrow"
            onClick={() =>
              setCurrentIndex((prev) => (prev + 1) % reviews.length)
            }
          ></i>
        </span>

        <div className="googleReviewLinkDiv">
          <Link
            to="https://g.co/kgs/VLQzMRF/"
            target="_blank"
            className="googleReviewLink googleReviewLinkForAll"
          >
            More Google Reviews
          </Link>
          <Link
            to="https://tinyurl.com/33ksykev/"
            target="_blank"
            className="googleReviewLink googleReviewLinkForComment"
          >
            Leave a comment here
          </Link>
        </div>
      </div>
    </>
  );
}

export default ClientReview;
